/* ============
 * New Release Version
 * ============
 *
 * This is the pop up modal.
 */
import accountService from './../../services/account';
import { mapGetters, mapMutations } from 'vuex';
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  data() {
    return {
      backendUrl: process.env.API_LOCATION,
      latestVersions: [],
      btnNextDisabled: false,
      btnPrevDisabled: true,
      maxDescLength: 250,
      releasePagination: '0 ' + this.$t('static.releaseNote.modal.pageOf') + ' 0',
      settings: {
        arrows: false,
        dots: false,
        infinite: false,
      },
    };
  },

  computed: {
    ...mapGetters([
            'latestAppVersion',
        ]),
  },

  methods: {

    ...mapMutations({
      toggleModal: 'TOGGLE_MODAL',
    }),

    closeModal() {
      this.toggleModal(false);
      Promise.resolve(accountService.updateUserAppVersion(this.latestVersions.version)).then(() => {});
    },

    rShowNext() {
      this.$refs.carousel.next();
    },

    rShowPrev() {
      this.$refs.carousel.prev();
    },

    handleAfterChange(event, slick, currentSlide) {
      if (event === 0) this.btnPrevDisabled = true;
      else this.btnPrevDisabled = false;
      if (event < this.latestVersions.release_modules_note.length) this.btnNextDisabled = false;
      else this.btnNextDisabled = true;
      this.releasePagination = (event + 1) + ' ' + this.$t('static.releaseNote.modal.pageOf') + ' ' + (this.latestVersions.release_modules_note.length + 1);
    },
  },

  mounted() {
    this.latestVersions = this.latestAppVersion.items.data;
    this.releasePagination = (this.latestVersions != '') ? '1 ' + ' ' + this.$t('static.releaseNote.modal.pageOf') + ' ' + (this.latestVersions.release_modules_note.length + 1) : '0 of 0';
  },

  components: { VueSlickCarousel },
};



// WEBPACK FOOTER //
// ./src/app/components/newReleaseVersion/newReleaseVersion.js